Ctrl.$inject = ['Authentication', '$window', '$scope', 'ClientCards', 'PortalApi', 'Notification', '$rootScope', '$state', '$translate', 'Localization', '$stateParams', 'Storage'];

function Ctrl(Authentication, $window, $scope, ClientCards, PortalApi, Notification, $rootScope, $state, $translate, Localization, $stateParams, Storage) {
    $scope.preLoader = false;
    $scope.infoState = '';
    $scope.activeCard = {};
    $scope.addNewCard = {
        name: "",
        number: "",
        month: "",
        year: "",
        cvv: ""
    };
    $scope.Authentication = Authentication;
    $scope.cards = ClientCards.list;
    $scope.cardsMP = ClientCards.listMP;
    $scope.disable_sms = {};
    $scope.cardInfo = {};
    $scope.docs = false;
    $scope.fieldVariable = false;
    $scope.haveCardType = '';
    $scope.masterpassActive = false;
    // $scope.masterpassStatus = Storage.mp_status;
    $scope.masterpassStatus = null;
    $scope.ClientCards = ClientCards;

    $rootScope.defaultCard = null;

    $rootScope.defaultCard = null;

    $scope.havePrepaid = function () {
        $scope.activeCardType();
        return $scope.cards.some(ClientCards.isPrepaid);
    };

    $scope.activeCardType = function() {
        var cardType = [];
        for (var i = 0; i < $scope.cards.length; i++) {
            cardType.push($scope.cards[i].card_type);
        }
        cardType.some(function (item) {
          if (item == 'shakhtar_fanid_prepaid') {
              $scope.haveCardType = 'shakhtar_fanid_prepaid';
          } else if (item == 'mc_prepaid_paypass_coala') {
              $scope.haveCardType = 'mc_prepaid_paypass_coala';
          }
        });
        if ($scope.cardsMP.length > 0) {
            $scope.haveCardType = 'masterpass';
        }
    };
    $scope.makeDefaultCard = function (card) {
        card.is_default = !card.is_default;
        $rootScope.defaultCard = card;

        for (var i = 0 ; i < $scope.cards.length; i++) {

            if (card.id == $scope.cards[i].id) {
                continue;
            }

            $scope.cards[i].is_default = false;
        }

        PortalApi.setDefaultCard(card);
    };


    $scope.fieldActiveFnc = function (id) {
      $scope.fieldVariable = !$scope.fieldVariable;
    };

    $scope.docs_active = function () {
      $scope.docs = !$scope.docs;
    };

    $scope.disable_services = function (type, card) {
      $scope.disable_sms = {
        type: type || null,
        card: card || null
      };
      if ($scope.disable_sms.type == 'blockCard') {
        $scope.preLoader = true;
        PortalApi.blockCard($scope.disable_sms.card.id).then(function(result) {
          if (result.status != 'error') {
            $scope.cardInfo.info.active = false;
            Localization.notifyTemplate('success', 'PREPAID.SUCCESS.BLOCK', 5, true);
          } else {
            Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
          }
        $scope.preLoader = false;
        });
      }
      if ($scope.disable_sms.type == 'enable3DS') {
        $scope.preLoader = true;
        PortalApi.enable3DS($scope.disable_sms.card.id).then(function(result) {
          if (result.status != 'error') {
            $scope.cardInfo.status3ds = false;
              Localization.notifyTemplate('success', 'PREPAID.SUCCESS.3DS_UNBLOCK', 5, true);
          } else {
              Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
          }
          $scope.preLoader = false;
        });
      }
    };

    $scope.takeCardInfo = function (card) {
      $scope.disable_sms = {};
      $scope.preLoader = true;
        PortalApi.getInfo(card.id).then(function (result) {
          $scope.preLoader = false;
          if (result.status != 'error') {
            $scope.cardInfo = {
              status: true,
              info: result.cardInfo,
              status3ds : result.status3DS,
              limits: {
                UsedCountLimit:  result.UsedCountLimit,
                AvailableCountLimit:  result.AvailableCountLimit,
                CountLimit:  result.CountLimit
              }
            };
          } else {
              Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 2, true);
          }
        }, function (reason) {
            $scope.preLoader = false;
            Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 2, true);
        });
    };

    $scope.init = function () {
        $scope.preLoader = true;

        // if ($stateParams.masterpassStatus) {
        //     $scope.masterpassStatus = Storage.mp_status = $stateParams.masterpassStatus;
        // }
        // if ($stateParams.authMP) {
        //     $scope.authMP();
        // } else if($stateParams.addMPCard && !$stateParams.newUser) {
        //     $scope.changeInfoState('add', undefined, true);
        // } else if ($stateParams.newUser) {
        //     if (Storage.mp_status == 'CONFIRMATION_NEEDED') {
        //         $scope.authMP();
        //     } else if (Storage.mp_status == 'REGISTRATION_NEEDED') {
        //         $scope.changeInfoState('add', undefined, true);
        //     }
        // } else {
        //     ClientCards.getList().then(function () {
        //         $scope.havePrepaid();
        //         $scope.clearState();
        //         $scope.cards.forEach(function (card) {
        //             if(card.is_default){
        //                 $rootScope.defaultCard = card;
        //             }
        //         })
        //         if ($stateParams.otp) {
        //             $scope.changeInfoState('checkOTP', undefined, true);
        //         }
        //     });
        // }

        ClientCards.getList().then(function () {
            $scope.havePrepaid();
            $scope.clearState();
            $scope.cards.forEach(function (card) {
                if(card.is_default){
                    $rootScope.defaultCard = card;
                }
            })
            if ($stateParams.otp) {
                $scope.changeInfoState('checkOTP', undefined, true);
            }
        });
    };

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.changeInfoState = function (state, card, masterpass) {
        var activeCard = {};

        if (state && card !== void 0) {
            activeCard = card;
        }
        if (activeCard.card_type == 'prepaid' ||
            activeCard.card_type == 'shakhtar_fanid_prepaid' ||
            activeCard.card_type == 'mc_prepaid_paypass_coala') {
          $scope.takeCardInfo(activeCard);
        }

        if (masterpass) {
            $scope.masterpassActived = true;
        } else {
            $scope.masterpassActived = false;
        }

        $scope.activeCard = activeCard;
        $scope.infoState = state;
        $scope.fieldVariable = false;
        $scope.preLoader = false;
    };

    $scope.masterpassActiveClick = function (mp) {
            if (mp) {
                $scope.clearMPCardInfo();
            }
    };

    $scope.clearMPCardInfo = function (data) {
        $scope.masterpassActived = false;
        $scope.addNewCard.month = "";
        $scope.addNewCard.year = "";
        $scope.addNewCard.cvv = "";
        if (data) {
            $scope.addNewCard.name = "";
            $scope.addNewCard.number = "";
        }
    };

    $scope.$on('validateSMS', function(e , data) {
        $scope.preLoader = true;
        ClientCards.verifyCodeMP(data).then(function () {

        }, function (reason) {
            $scope.preLoader = false;

            Notification.error({
                message: reason,
                delay: 5000
            });
       });
    });

    $scope.$on('getList', function() {
        $scope.preLoader = true;
        // $scope.masterpassStatus = Storage.mp_status;
        ClientCards.getList(true).then(function () {
            $scope.clearState();
        });
    });

    $scope.clearState = function (errorText) {

        $scope.changeInfoState();
        $scope.clearMPCardInfo(true);

        $scope.cardInfo = {};
        $scope.activeCard = {};
        $scope.preLoader = false;
    };

    $scope.addNew = function(form) {
        var hash = ClientCards.getCardHash(form.number);
        var data = {
            alias: form.name,
            pan: form.number.replace(/\s/gi,""),
            exp: form.year + form.month,
            cvv: form.cvv
        }
        $scope.preLoader = true;

        if ($scope.masterpassActived) {
            ClientCards.addMP(data).then(function (res) {
                if( res.status == '3DS_VALIDATION' && res.secure3d) {
                    Authentication.removeSession();
                    $window.location.href = res.secure3d.ascUrl;
                }
                else {
                    $translate('AUTH.SMS-TIP').then(function(message) {
                        Notification.success({
                            message: message,
                            delay: 5000
                        });
                    });
                    $scope.clearMPCardInfo(true);
                    $scope.changeInfoState('checkOTP', undefined, true);
                }

            }, function (reason) {
                $scope.preLoader = false;

                Notification.error({
                    message: reason,
                    delay: 5000
                });
            });
        } else {
            ClientCards.add(form).then(function () {
                $translate('MYCARDS.SUCCESS_ADD', {cardhash: hash}).then(function(message) {
                    Notification.success({
                        message: message,
                        delay: 5000
                    });
                });

                $scope.havePrepaid();
                $scope.clearState();
            }, function (reason) {
                $scope.preLoader = false;

                Notification.error({
                    message: reason,
                    delay: 5000
                });
            });
        }
    };

    $scope.remove = function() {
        $scope.preLoader = true;

        ClientCards.remove($scope.activeCard).then(function () {
            $translate('MYCARDS.SUCCESS_REMOVE', {cardhash: $scope.activeCard.number}).then(function(message) {
                Notification.success({
                    message: message,
                    delay: 5000
                });
            });

            // $scope.masterpassStatus = Storage.mp_status;
            $scope.havePrepaid();
            $scope.clearState();
        }, function (reason) {
            $scope.preLoader = false;

            Notification.error({
                message: reason,
                delay: 5000
            });
        });
    };

    $scope.rename = function(name) {
        $scope.preLoader = true;
        $scope.activeCard.name = name;

        ClientCards.rename($scope.activeCard).then(function () {
            $translate('MYCARDS.SUCCESS_UPDATE', {cardhash: $scope.activeCard.number}).then(function(message) {
                Notification.success({
                    message: message,
                    delay: 5000
                });
            });

            $scope.preLoader = false;
            $scope.fieldActiveFnc();
        }, function (reason) {
            $scope.preLoader = false;

            Notification.error({
                message: reason,
                delay: 5000
            });
        });
    };

    $scope.forgotMasterpassPass = function() {
    };

    $scope.authMP = function() {

        if ($scope.infoState == 'authMasterpass') {
            return;
        }

        $scope.preLoader = true;

        ClientCards.initMPWalletLink('').then(function () {
            $scope.infoState = 'authMasterpass';
            $scope.preLoader = false;
        }, function (reason) {

            Notification.error({
                message: reason,
                delay: 5000
            });

            $scope.preLoader = false;
        });
    };

    $scope.init();
}

module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/controllers/mycards.controller.js
 ** module id = 272
 ** module chunks = 1
 **/